import { render, staticRenderFns } from "./Inherit.vue?vue&type=template&id=1f206a88&scoped=true&"
import script from "./Inherit.vue?vue&type=script&lang=js&"
export * from "./Inherit.vue?vue&type=script&lang=js&"
import style0 from "./Inherit.vue?vue&type=style&index=0&id=1f206a88&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f206a88",
  null
  
)

export default component.exports